/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { FittingTreeView } from '@hcworkspace/sysque/toolbelt/feature';
import { FittingTreeViewComponent } from 'libs/sysque/toolbelt/feature/src/lib/components/add-fitting-tab/fitting-tree-view/fitting-tree-view.component';
import { BehaviorSubject, Observable } from 'rxjs';

export interface IFittingTreeViewFacade {
  getResultInformationFromTreeViewFolder(validItems: FittingTreeView[]): unknown;
  updateTreeViewNodeOnExpansionChanged(itemData: any): Promise<any>;
  getTreeViewItems(): Observable<any>;
  updateSelectorForResult(): void;
  getLocalStorageUpdate(): BehaviorSubject<string>;
  setFittingTreeViewInstance(fittingTreeView: FittingTreeViewComponent): void;
}

export const FITTING_TREE_VIEW_FACADE_TOKEN = new InjectionToken<IFittingTreeViewFacade>(
  'FITTING_TREE_VIEW_FACADE_TOKEN'
);
